export default __webpack_public_path__ + "static/media/telefono-movil.357b95cb.png";